import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const dashboardAPI = {
  revenue_by_sale_agency: ({ ...params }: Record<string, string | number>) =>
    http
      .get<DashboardRevenue[]>(`/api/info/revenue_by_sale_agency/${params.year}/${params.month}`)
      .then(({ data }) => data),

  lead_gender: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadGender>(`/api/info/dashboard/gender`, { params }).then(({ data }) => data),
  lead_dob: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadDob>(`/api/info/dashboard/dob`, { params }).then(({ data }) => data),
  lead_contact_source: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadContactSource>(`/api/info/dashboard/contact_source`, { params }).then(({ data }) => data),
  lead_product: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadProduct>(`/api/info/dashboard/lead_product`, { params }).then(({ data }) => data),
  lead_sale_agency: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadSaleAgency>(`/api/info/dashboard/sale_agency`, { params }).then(({ data }) => data),
  lead_province: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadSaleAgency>(`/api/info/dashboard/province`, { params }).then(({ data }) => data),
  revenue_by_employee: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardRevenueByEmployee[]>(`/api/info/revenue_by_employee`, { params }).then(({ data }) => data),
  lead_status: ({ ...params }: Record<string, string | number>) =>
    http.get<DashboardLeadStatus>(`/api/info/dashboard/status`, { params }).then(({ data }) => data),
};

export const dashboardQuery = {
  revenue_by_sale_agency: (params: Record<string, string>) =>
    ({
      queryKey: ['GetRevenueBySaleAgency', params] as const,
      queryFn: () => dashboardAPI.revenue_by_sale_agency(params),
    }) as const satisfies QueryOptions,
  lead_gender: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadGender', params] as const,
      queryFn: () => dashboardAPI.lead_gender(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  lead_dob: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadDob', params] as const,
      queryFn: () => dashboardAPI.lead_dob(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  lead_contact_source: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadContactSource', params] as const,
      queryFn: () => dashboardAPI.lead_contact_source(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  lead_product: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadProduct', params] as const,
      queryFn: () => dashboardAPI.lead_product(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  lead_sale_agency: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadSaleAgency', params] as const,
      queryFn: () => dashboardAPI.lead_sale_agency(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  lead_province: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadSaleAgency', params] as const,
      queryFn: () => dashboardAPI.lead_province(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  revenue_by_employee: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetRevenueByEmployee', params] as const,
      queryFn: () => dashboardAPI.revenue_by_employee(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
  lead_status: (params: Partial<SearchData>) =>
    ({
      queryKey: ['GetDashboardLeadStatus', params] as const,
      queryFn: () => dashboardAPI.lead_status(getQueryParameters({ params })),
    }) as const satisfies QueryOptions,
};
